const suffix = process.env.GATSBY_BRAND_CONFIG_SUFFIX
const config = require(`./brandConfig_${suffix || 'kto'}.json`)

export const brandConfig = config
